export enum SetTimingKinds {
  /** 無し */
  None = 1,
  /** 記載開始(初回作成時) */
  EditStartFirst = 2,
  /** 記載開始 */
  EditStart = 3,
  /** 印刷 */
  Print = 4,
  /** 登録なしの印刷 */
  NoSavePrint = 5,
  /**
   * 記載開始時以外    
   * Print    
   * SaveFile    
   * SavePdf    
   * SaveReport
   */
  OtherEditStart = 6,
  /** 書類保存 */
  SaveReport = 7,

  // ------- 以下、WF用-------------

  /** WF依頼書 初回記載 */
  WorkflowRequest = 2000,
  /**
   * ・直接記載時：記載開始(初回作成時)    
   * ・ワークフロー(設定による)：ワークフローの依頼 or 最終書類作成ステータスの記載開始
   */
  WorkflowConfig = 2001,

  /** WF文書 下書き進捗で初回記載 */
  WorkflowDraftEditStartFirst = 2200,
  /** WF文書 作成1進捗で初回記載 */
  WorkflowMake1EditStartFirst = 2300,
  /** WF文書 作成2進捗で初回記載 */
  WorkflowMake2EditStartFirst = 2400,
  /** WF文書 承認進捗で承認 */
  WorkflowRecognize = 2500,
}
